"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-explicit-any */
const accounting_1 = __importDefault(require("accounting"));
const accountingConfiguration = {
    de: {
        currency: {
            symbol: '\u20ac',
            format: '%v %s',
            decimal: ',',
            thousand: '.',
            precision: 2,
        },
        number: {
            precision: 2,
            decimal: ',',
            thousand: '.',
        },
    },
    en: {
        currency: {
            symbol: '\u20ac',
            format: '%s%v',
            decimal: '.',
            thousand: ',',
            precision: 2,
        },
        number: {
            precision: 2,
            decimal: '.',
            thousand: ',',
        },
    },
};
function sanitizeNumber(value) {
    if (typeof value === 'number' || typeof value === 'string') {
        return value;
    }
    return NaN;
}
function formatMoney(locale, number, options = {}) {
    const number_ = sanitizeNumber(number);
    accounting_1.default.settings = accountingConfiguration[locale] ?? accounting_1.default.settings;
    return accounting_1.default.formatMoney(number_, options);
}
exports.default = formatMoney;
//# sourceMappingURL=formatMoney.js.map